import WorkIm from '../assets/projects/phonePe.png'
import RealEst from '../assets/projects/dice.png'

export const data=[
    {
        id:1,
        name:"Virtual Dice Roller Application",
        image:RealEst,
        github:"",
        live:"",
    },
    {
        id:2,
        name:"PhonePe Application",
        image:WorkIm,
        github:"https://www.google.com",
        live:"",
    },
    // {
    //     id:3,
    //     name:"React JS Application",
    //     image:WorkIm,
    //     github:"",
    //     live:"",
    // },
    // {
    //     id:4,
    //     name:"React JS Application",
    //     image:RealEst,
    //     github:"",
    //     live:"",
    // },


]